import React from 'react';
import { Button, Nav, Container } from 'react-bootstrap';

const Footers = () => {
  return (
    
    <footer className="my-4 pt-5 text-muted text-center text-small">
          <div className="container">
            <p className="mb-1"> Copyright © Republic Polytechnic. All Rights reserved.</p>
            <ul className="list-inline">
                <li className="list-inline-item"><a href="https://www.rp.edu.sg/disclaimer" target="_blank">Disclaimer</a></li>
                <li className="list-inline-item"><a href="https://www.tech.gov.sg/report_vulnerability" target="_blank">Report Vulnerability</a></li>
                <li className="list-inline-item"><a href="https://www.rp.edu.sg/privacy-statement" target="_blank">Privacy Statement</a></li>
                <li className="list-inline-item"><a href="https://www.rp.edu.sg/terms-of-service" target="_blank">Terms of Service</a></li>
            </ul>
        </div>
    </footer>
  );
}

export default Footers;
